import './Logo.css';

/**
 * The single Walkin logo used across the walker-facing flow: a circular
 * purple-to-blue gradient badge with a white pin icon, followed by the
 * "Walkin" (off-white) / "Deals" (brand blue) wordmark.
 *
 * `size` is the wordmark font-size in px; the badge and pin scale with it.
 * There is intentionally only ONE logo component — do not fork variants.
 */
export default function Logo({ size = 26, className = '' }) {
  const badge = Math.round(size * 1.38);
  const pin = Math.round(size * 0.69);
  const gap = Math.round(size * 0.38);

  return (
    <div className={`logo ${className}`.trim()} style={{ gap }}>
      <div
        className="logo__badge"
        style={{ width: badge, height: badge }}
      >
        <svg
          className="logo__pin"
          style={{ width: pin, height: pin }}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      </div>
      <div className="logo__text" style={{ fontSize: size }}>
        <span className="logo__walk">Walkin</span>{' '}
        <span className="logo__in">Deals</span>
      </div>
    </div>
  );
}
